import { CartItemInterface, Maybe, Scalars } from '@pylot-data/pylotschema'

import { isConfigItem } from './processConfigurableItem'

export const findCartItem = (
    items: Maybe<CartItemInterface>[],
    options: Maybe<Array<Maybe<Scalars['ID']>>> | undefined,
    sku: string
): Maybe<CartItemInterface> | undefined => {
    return items.find((item) => {
        if (!item || item.product.sku !== sku) {
            return false
        }
        if (!isConfigItem(item) || !options) {
            return true
        }
        // Find config options of the cart item, that do not match new options
        const notMatchingOptions = item.configurable_options.filter(
            (option) =>
                !option ||
                !options.includes(option.configurable_product_option_value_uid)
        )
        return !notMatchingOptions.length
    })
}
